<template>
  <div class="data-box" :style="{width:width,height:height}">
    <div class="line-box"><i class="t-l-line"></i><i class="l-t-line"></i></div>
    <div class="line-box"><i class="t-r-line"></i><i class="r-t-line"></i></div>
    <div class="line-box"><i class="l-b-line"></i><i class="b-l-line"></i></div>
    <div class="line-box"><i class="r-b-line"></i><i class="b-r-line"></i></div>
  </div>
</template>

<script>
  const cityOptions = ['上海', '北京'];
  export default {
    props: {
      width: {
        type: String,
        default: '400px'
      },
      height: {
        type: String,
        default: '300px'
      }
    },
    data() {
      return {
      }
    },
    mounted() {},
    computed: {

    },
    methods: {
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .centerFooter2 {
    float: right;
    justify-content: space-between;
    // float:right;
    //    justify-content: space-between;
    //    align-items: center;
    // cursor: pointer;
    //    background: rgba(18, 136, 207, 0.38);
    //    border-radius: 2px;
    // font-size:14px;
    //    border: 1px solid #5B6578;
    // color:#5B6578;
    // div{
    // 		padding: 4px 8px;
    // 		cursor: pointer;
    // }
    // span{

    // }
    // .isActive{
    // 	color:#fff;
    // 	border:1px solid #FFF;
    // }
  }

  .allCount {
    text-align: left;
    .in-title {
      color: #2771AE;
      height: 38px;
      padding: 10px 10px 10px 20px;
      font-weight: bold;
      font-size: 14px;
      margin-top: 3px;
      z-index: 1000;



    }
  }

  .data-box {
    width: 100%;
    background-color: rgba(0, 0, 0, 0);
    border: 1px solid rgba(73, 146, 193, 0.45);
    box-shadow: 0px -1px 20px 0px rgba(0, 146, 255, 0.32);
    position: relative;

    .chart {
      height: calc(100% - 38px);
    }

    .chartNoTitle {
      height: 100%;
    }

    .in-title {
      color: rgba(0, 180, 255, 1);
      width: 100%;
      height: 38px;
      padding: 8px 10px 8px 20px;
      font-size: 22px;
      margin-top: 3px;
      z-index: 1000;
      font-family: Source Han Sans CN;
      font-weight: 400;

      span {
        margin-left: 5px;
      }
    }

    .line-box {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 0;

      i {
        background: rgba(119, 192, 235, 1);
        -webkit-box-shadow: 0px 0px 1px rgba(119, 192, 235, 1);
        box-shadow: 0px 0px 10px rgba(119, 192, 235, 1);
        position: absolute;
        font-style: normal;
      }

      i.l-t-line {
        width: 1px;
        height: 10px;
        left: -1px;
        top: -1px
      }

      i.t-l-line {
        height: 1px;
        width: 10px;
        left: -1px;
        top: -1px
      }

      i.t-r-line {
        height: 1px;
        width: 10px;
        right: -1px;
        top: -1px
      }

      i.r-t-line {
        width: 1px;
        height: 10px;
        right: -1px;
        top: -1px
      }

      i.l-b-line {
        width: 1px;
        height: 10px;
        left: -1px;
        bottom: -1px
      }

      i.b-l-line {
        height: 1px;
        width: 10px;
        left: -1px;
        bottom: -1px
      }

      i.r-b-line {
        width: 1px;
        height: 10px;
        right: -1px;
        bottom: -1px
      }

      i.b-r-line {
        height: 1px;
        width: 10px;
        right: -1px;
        bottom: -1px
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Box.vue